<template>
    
</template>
<script>
import { defineComponent } from 'vue'
import { userByCondition} from '@/api/heimingdan/heimingdan';
//import WageSlipDetail from './Detail.vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import { isHaveOrgPower } from '@/utils/common';
export default defineComponent({
    emits: ['update:modelValue', 'get-data'],
    components:{},
    props: {
        detailVisible: Boolean,
        editData: Object,
        'getData': Function,  // 上传成功回调
    },
    computed: {
        // detailVisible: {
        //     get() {
        //         return this.modelValue;
        //     },
        //     set(value) {
        //         this.$emit('update:modelValue', value)
        //     }
        // }
    },
    data(){
        return{
            loading: false,
            userParam:{
                name:null,
                idCardNo:null,
                phone:null
            },
            fileList:[],
            files:[],
        }
    },
    mounted(){},
    methods:{
        isEdit(){
            return this.editData&&Object.keys(this.editData).length>0?true:false;
        },
        handleSelect(item){
            if(item&&Object.keys(item).length>0){
                this.editData.name=item.name;
                this.editData.idCardNo=item.idCardNo;
                this.editData.phone=item.phone;
                this.editData.sex=item.sex;
                this.editData.address=(item.idProvince?item.idProvince:"")+(item.idCity?item.idCity:"")+(item.idCounty?item.idCounty:"")+item.address;
            }
        },
        querySearch(queryString, cb) {
            this.userParam.name=queryString;
            userByCondition(this.userParam).then(res=>{console.log('userByCondition',res);
                if(true==res.status){
                    // var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                    // 调用 callback 返回建议列表的数据
                    cb(res.data);
                }
            });
        },
        impRemove(file, fileList) {
            console.log(file, fileList);
        },
        impPreview(file) {
            console.log(file);
        },
        imgUpBefore(file){console.log(file);
            let f={name:file.name,url:URL.createObjectURL(file),file};
            this.fileList.push(f);
        }
    }
})
</script>
<style lang="scss" scoped>
</style>